import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {truBlueStatus, truBlueRegistrationPeriod} from 'helpers/constants';
import {injectIntl, FormattedMessage} from 'react-intl';

class TrublueBanner extends React.Component {

  static propTypes = {
    customer: PropTypes.object.isRequired,
    pools: PropTypes.array.isRequired,
    contactName: PropTypes.string.isRequired,
    manageTruBlueState: PropTypes.func.isRequired,
    intl: PropTypes.any,
  };

  state = {
    isCustomerActive: false,
    activePoolCandidates: 0,
  };


  componentDidMount = () => {
    let {customer, pools} = this.props;

    this.setState({
      isCustomerActive: customer.truBlueStatus === truBlueStatus.Active,
      activePoolCandidates: pools.filter(p => p.truBlueStatus === truBlueStatus.Eligible || p.truBlueStatus === truBlueStatus.Opportunity ||
        p.truBlueStatus === truBlueStatus.Inactive).length,
    });

  };

  componentWillReceiveProps = nextProps => {
    let {customer, pools} = nextProps;

    this.setState({
      isCustomerActive: customer.truBlueStatus === truBlueStatus.Active,
      activePoolCandidates: pools.filter(p => p.truBlueStatus === truBlueStatus.Eligible || p.truBlueStatus === truBlueStatus.Opportunity ||
        p.truBlueStatus === truBlueStatus.Inactive).length,
    });

  };

  getTruBlueContent() {
    let {customer, contactName} = this.props;
    let {formatMessage} = this.props.intl;
    let {isCustomerActive, activePoolCandidates} = this.state;

    if (isCustomerActive) {
      if (activePoolCandidates === 0) {
        return <p>
          <FormattedMessage id='trublue.banner.allactive.message'
                            values={{
                              customer: contactName || formatMessage({id: 'general.customer'}),
                            }}/>
        </p>;
      }

      return <p>
        <FormattedMessage id='trublue.banner.active.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                            n: activePoolCandidates,
                          }}/>
      </p>;
    }

    if (customer.truBlueStatus === truBlueStatus.Opportunity) {
      return <p>
        <FormattedMessage id='trublue.banner.opportunity.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                          }}/>
      </p>;
    }

    if (customer.truBlueStatus === truBlueStatus.Inactive) {
      return <p>
        <FormattedMessage id='trublue.banner.inactive.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                            renew: <strong>{formatMessage({id: 'general.renew'}).toUpperCase()}</strong>,
                          }}/>
      </p>;
    }


    if (customer.truBlueStatus === truBlueStatus.Eligible) {
      return <p>
        <FormattedMessage id='trublue.banner.eligible.message'
                          values={{
                            customer: contactName || formatMessage({id: 'general.customer'}),
                            eligible: <strong>{formatMessage({id: 'general.eligible'}).toUpperCase()}</strong>,
                          }}/>
      </p>;
    }

    return null;
  }


  render() {
    let {customer, manageTruBlueState, intl} = this.props;
    let {isCustomerActive} = this.state;
    let isTBRegistrationClosed = moment().isAfter(truBlueRegistrationPeriod.end) ||
      moment().isBefore(truBlueRegistrationPeriod.start);

    if (isTBRegistrationClosed ||
      !customer.truBlueStatus ||
      customer.truBlueStatus === truBlueStatus.Ineligible) {
      return null;
    }

    const {formatMessage, locale} = this.props.intl;

    return <div className={classNames('trublue-banner', {
      'trublue-banner--active': isCustomerActive,
      'trublue-banner--inactive': !isCustomerActive,
    }, 'pointer')}
                onClick={manageTruBlueState(false)}>
      <span className="trublue-banner__item">
        <i className={classNames('bl', 'icon', 'bl-tru-blue-icon bl-tru-blue-filled', 'bl-tru-blue-circle-icon', {
          'blue': isCustomerActive,
          'grey': !isCustomerActive,
        })}/>
      </span>
      <span className="trublue-banner__item">
        <img src={locale === 'fr-CA' ? '/Content/img/trublue/trublue-promise-logo-fr.png' : '/Content/img/trublue/trublue-promise-logo.png'}
               alt={formatMessage({id: 'trublue.promise'})}
               className='trublue-banner__logo'/>
      </span>
      <span className="trublue-banner__item trublue-banner__keyline"/>
      <div className="trublue-banner__item trublue-banner__content">
        {this.getTruBlueContent()}
      </div>
    </div>;
  }


}

export default injectIntl(TrublueBanner);
